const initialState = {
  projectDetail: null,
  permissionFlags: null,
  deletePermissionPending: false,
  deletePermissionError: null,
  getFlagsPending: false,
  getFlagsError: null,
  loadProjectDetailPending: false,
  loadProjectDetailError: null,
};

export default initialState;
